/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class SectionThree extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section section-3-et -three --black block-3 z-12">
                    <div className="container relative-text">
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <br className="hide-on-med-and-up"/>
                                <h1 className="f-38 white-text bold-text text-uppercase">Attend Our First Annual 7-Day Festival
                                    <br/>
                                    <br/>
                                    <span className="f-100-long ls-3">Conference<br/><span className="--brand-shadow white-text">+</span><br/></span><span className="f-100-long ls-3">Hackathon</span></h1>
                                <p className="f-22 white-text center-align">Disrupt Puerto Rico is an exciting new tech & music festival, being held in San Juan, PR. It consists of 7 days of meetups, workshops, speaker sessions, pitch competitions, fireside chats, keynotes and a hackathon for social good! It is designed to bring together software professionals and entrepreneurs across languages, platforms, and industries. Participants will have opportunities to network, engage, and learn about trending and up-and-coming topics that are shaping the future of technology and business, today. Join our elite panel of experts in a fantastic series of talks, workshops, and presentations that include topics such as Entrepreneurship, Marketing, Scaling Startups, Angel Investing, Fintech, Artificial Intelligence and more. </p>
                                <p className="f-22 white-text center-align ">
                                    <br/>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <br/>
                                </p>
                            </div>
                        </div>
                        <div className="hide m0 valign-wrapper hide-on-med-and-down">
                            <div className="col s12 m6 l6 center-align p0">
                                <img className="img-sticky responsive-img" src="../static/sofia-stolberg.png" alt="sofia-stolberg" />
                            </div>
                            <div className="col s12 m6 l6 center-align p0">
                                <h1 className="f-62 brand-text text-uppercase text-normal right-align mobile-center mb0">Make Your <br className="hide-on-med-and-down"/><span className="f-84 ls-3 white-text bold-text m0">Impact</span></h1>
                                <p className="f-26 brand-text right-align mobile-center m0">This is not a boring <br className="hide-on-med-and-down"/> seminar or secret sales event.</p>
                                <p className="f-32 grey-text-3 text-normal text-uppercase right-align mobile-center m0">There is no gimmick.</p>
                                <h1 className="f-32 brand-text text-uppercase right-align mobile-center">Just leaders <br className="hide-on-med-and-down"/> creating leaders.</h1>
                                <div className="col s12 right-align mobile-center p0">
                                    <a href="#" className="btn-large brand-cta waves-effect waves-light">BUY TICKET</a>
                                    <br/>
                                    <br/><br className="hide-on-small-only"/><br className="hide-on-small-only"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default SectionThree;



// WEBPACK FOOTER //
// ./src/components/section-three.js